import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { Store } from 'app-redux/types/storeTypes';
import { HoroscopesAndPredictionsChildInterface } from 'types/componentTypes';
import { DailyHoroscope } from 'components/Sections/HoroscopesSignsHoroscopesAndPredictions/DailyHoroscope';

const DailyHoroscopeContainer: React.FC<HoroscopesAndPredictionsChildInterface> = ({
  block: dailyHoroscope,
  zodiacSign,
}) => {
  const { mobileViewMaxWidth } = useSelector((store: Store) => store.server.app.scssVariables);
  const isMobileViewWidth = useSelector((store: Store) => store.server.app.isMobileViewWidth);
  const { locale } = useRouter();

  return (
    <DailyHoroscope
      dailyHoroscope={dailyHoroscope as any}
      zodiacSign={zodiacSign}
      mobileViewMaxWidth={+mobileViewMaxWidth}
      isMobileViewWidth={isMobileViewWidth}
      locale={locale}
    />
  );
};

export default DailyHoroscopeContainer;
